import {zodResolver} from '@hookform/resolvers/zod';
import {useRefundRequest} from 'presentation/pages/private/refund/hooks';
import {useAccountDataStore} from 'presentation/pages/private/store/useAccountDataStateStore';
import {useForm} from 'react-hook-form';
import {useTherapiesDataStore} from '../../../store/useTherapiesDataStore';
import {therapyDataSchema, type TherapyDataSchema} from '../schemas/therapyDataSchema';

export const emptySessionBuilder = (id?: number): TherapyDataSchema['sessions'][0] => ({
	serviceDate: '',
	sessionValue: '',
	id: id ? id.toString() : '1',
	isSaved: false,
});

export const useFormManagement = () => {
	const {formAtoms} = useRefundRequest();
	const {planBeneficiaries} = useAccountDataStore(store => store.accountData);
	const editingTherapy = useTherapiesDataStore(state => state.editingTherapy);

	const patientUserCode = formAtoms.patientDataForm.patient?.userCode;
	const dtCancelamento = planBeneficiaries?.find(
		beneficiary => beneficiary.cdUsuarioC === patientUserCode,
	)?.dtCancelamentoC;

	const therapyDataMethods = useForm<TherapyDataSchema>({
		resolver: zodResolver(therapyDataSchema(dtCancelamento)),
		defaultValues: editingTherapy
			? editingTherapy.therapy
			: {
					therapyType: undefined,
					sessions: [],
				},
		mode: 'onSubmit',
	});
	return {therapyDataMethods};
};
